import { root } from 'app/store/constants';

const TYPE_SWITCHER_MINIMIZED_WIDTH = 1366; //px

export const isSwitcherMinimizedByAside = (
): boolean => {
    return root._innerWidth < TYPE_SWITCHER_MINIMIZED_WIDTH;
};
